import {
  Stethoscope, Heartbeat, Brain, Bone, Bandaids, Wind, Waveform, Pill,
  FlowerTulip, Drop, Sparkle, Pulse, ChatCircle, TestTube, Scan,
  FirstAidKit, Ambulance, FolderOpen, ClockCounterClockwise, Files,
  MagnifyingGlass, Package, Butterfly, Heart, Baby, UsersThree, HandHeart,
  Plant, Syringe, Users, Ruler, Truck, ShieldCheck,
} from "@phosphor-icons/react";

export const SPECIALTIES = [
  { name: "Medicina Interna", Icon: Stethoscope },
  { name: "Cardiología", Icon: Heartbeat },
  { name: "Neurología", Icon: Brain },
  { name: "Traumatología", Icon: Bone },
  { name: "Reumatología", Icon: Bandaids },
  { name: "Neumología", Icon: Wind },
  { name: "Digestivo", Icon: Waveform },
  { name: "Endocrinología", Icon: Pill },
  { name: "Ginecología", Icon: FlowerTulip },
  { name: "Urología", Icon: Drop },
  { name: "Dermatología", Icon: Sparkle },
  { name: "Psiquiatría", Icon: Pulse },
  { name: "Psicología", Icon: ChatCircle },
  { name: "Análisis", Icon: TestTube },
  { name: "Pruebas de imagen", Icon: Scan },
  { name: "Hospitalizaciones", Icon: FirstAidKit },
  { name: "Urgencias", Icon: Ambulance },
  { name: "Otros", Icon: FolderOpen },
];

export const PROBLEMS = [
  { text: "Buscar un informe cinco minutos antes de entrar al médico.", Icon: ClockCounterClockwise },
  { text: "Llevar varias carpetas diferentes.", Icon: FolderOpen },
  { text: "Tener informes mezclados.", Icon: Files },
  { text: "Perder tiempo organizando documentos.", Icon: Package },
  { text: "No recordar dónde guardaste una prueba.", Icon: MagnifyingGlass },
];

export const FEATURES = [
  { text: "Índice personalizado por especialidades", Icon: Files },
  { text: "Fundas transparentes antibacterianas", Icon: ShieldCheck },
  { text: "Separadores por especialidad", Icon: FolderOpen },
  { text: "Encuadernación en espiral", Icon: Package },
  { text: "Tamaño A4", Icon: Ruler },
  { text: "Fácil de transportar", Icon: Truck },
  { text: "Diseño elegante", Icon: Sparkle },
  { text: "Pensada para años de uso", Icon: ClockCounterClockwise },
];

export const BENEFITS = [
  { text: "Encuentra tus informes en segundos.", Icon: MagnifyingGlass },
  { text: "Reduce el estrés antes de las consultas.", Icon: Heart },
  { text: "Mantén toda tu historia clínica organizada.", Icon: Files },
  { text: "Fundas antibacterianas que protegen tus documentos.", Icon: ShieldCheck },
  { text: "Incluye un sobre para tus volantes y tickets de farmacia o consultas.", Icon: Package },
  { text: "Ideal para pacientes crónicos.", Icon: Heart },
  { text: "Perfecta para cualquier persona que quiera cuidar su documentación médica.", Icon: Users },
];

export const AUDIENCES = [
  { name: "Pacientes crónicos", Icon: ClockCounterClockwise },
  { name: "Endometriosis", Icon: FlowerTulip },
  { name: "Enfermedades raras", Icon: Sparkle },
  { name: "Ehlers-Danlos", Icon: Bandaids },
  { name: "Fibromialgia", Icon: Waveform },
  { name: "Personas mayores", Icon: Heart },
  { name: "Niños", Icon: Butterfly },
  { name: "Familias", Icon: UsersThree },
  { name: "Pacientes oncológicos", Icon: HandHeart },
  { name: "Embarazo", Icon: Baby },
  { name: "Fertilidad", Icon: Plant },
  { name: "Trasplantes", Icon: Syringe },
  { name: "Síndromes compresivos vasculares", Icon: Heartbeat },
];
